<template>
    <div class="l-nav">
        <div class="container">
            <div class="header_logo">
                <a :href="constants.MATCHA_SITE + languageName">
                    <img src="@/static/images/logo.webp" width="360" height="96" alt="MATCHA" />
                </a>
            </div>
            <div id="menuTrigger" class="header_menuTrigger icon-menu" v-on:click="openMenu"></div>
            <div id="menu" class="header_menu">
                <div class="menuHeader">
                    <span class="menuClose icon-cancel" v-on:click="closeMenu"></span>
                </div>
                <!-- For User Login System  -->
                <div class="userMenu sp beforeLogin" id="beforeLogin" v-if="!this.isLogin">
                    <router-link to="login" class="login btn btn-green">
                        {{
                        $t("header.user.login")
                        }}
                    </router-link>
                    <router-link to="register" class="sign-up text-link">
                        {{
                        $t("header.user.create_account")
                        }}
                    </router-link>
                </div>
                <div class="menuGroup userMenu sp" v-else>
                    <ul id="dropdownMenu" class="dropdownMenu">
                        <li>
                            <div
                                class="menuTitle arrow"
                                @click="showDropDown($event)"
                            >{{ $t("ユーザー") }}</div>
                            <ul class="dropdown top_header">
                                <li>
                                    <router-link to="/" v-on:click.native="closeMenu">
                                        {{
                                        $t("マイページ")
                                        }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="settings" v-on:click.native="closeMenu">
                                        {{
                                        $t("header.user.settings_modification")
                                        }}
                                    </router-link>
                                </li>
                                <li class="top_menu_listall">
                                    <a href="javascript:;" @click.prevent="logout()">
                                        {{ $t("header.user.logout") }}
                                        <span></span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div class="menuGroup mainMenu">
                    <ul id="dropdownMenu" class="dropdownMenu">
                        <li>
                            <div
                                class="menuTitle arrow"
                                @click="showDropDown($event)"
                            >{{ $t("header.menu.area") }}</div>
                            <ul class="dropdown top_header">
                                <li v-for="(region, index) in $t('header.area_list')" :key="index">
                                    <a
                                        :href="
                      constants.MATCHA_MEDIA_SSL_URL +
                        languageName +
                        '/list/?region=' +
                        region.id +
                        '&category=all'
                    "
                                    >{{ region.name }}</a>
                                </li>
                                <li class="top_menu_listall">
                                    <a
                                        :href="
                      constants.MATCHA_MEDIA_SSL_URL +
                        languageName +
                        '/list/region'
                    "
                                    >
                                        {{ $t("すべてのエリア") }}
                                        <span></span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <div
                                class="menuTitle arrow"
                                @click="showDropDown($event)"
                            >{{ $t("header.menu.interest") }}</div>
                            <ul class="dropdown">
                                <li
                                    v-for="(interest, index) in $t('header.interest_list')"
                                    :key="index"
                                >
                                    <a
                                        :href="
                      constants.MATCHA_MEDIA_SSL_URL +
                        languageName +
                        '/list/?region=all&category=' +
                        interest.id
                    "
                                    >{{ interest.name }}</a>
                                </li>
                                <li class="top_menu_listall">
                                    <a
                                        :href="
                      constants.MATCHA_MEDIA_SSL_URL +
                        languageName +
                        '/list/category'
                    "
                                    >
                                        {{ $t("すべてのカテゴリー") }}
                                        <span></span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <div
                                class="menuTitle arrow"
                                @click="showDropDown($event)"
                            >{{ $t("header.menu.travel_tips") }}</div>
                            <ul class="dropdown">
                                <li
                                    v-for="(travel_tips, index) in $t('header.travel_tips_list')"
                                    :key="index"
                                >
                                    <a
                                        :href="
                      constants.MATCHA_MEDIA_SSL_URL +
                        languageName +
                        '/list/index?' +
                        'region=all&category=' +
                        travel_tips.id
                    "
                                    >{{ travel_tips.name }}</a>
                                </li>
                            </ul>
                        </li>

                        <li v-if="isShowBookingMenu()">
                            <div class="menuTitle arrow" @click="showDropDown($event)">
                                {{$t("header.menu.booking")}}
                            </div>
                            <ul class="dropdown">
                                <li>
                                    <a :href="constants.MATCHA_MEDIA_SSL_URL + languageName + '/booking'">
                                        {{ $t("header.menu.booking") }}
                                    </a>                                    
                                </li>
                                <li>
                                    <a :href="$t('header.menu.eventticket_url')">
                                        {{ $t("header.menu.eventticket") }}
                                    </a>                                    
                                </li>                                
                            </ul>                            
                        </li>

                        <li v-if="isShowNewsMenu()">
                            <a class="menuTitle" :href="constants.MATCHA_MEDIA_SSL_URL + languageName + '/news'">
                                {{ $t("header.menu.news") }}
                            </a>
                        </li>                        
                    </ul>
                </div>
                <div class="menuGroup company">
                    <div class="menuGroupLabel">MATCHA</div>
                    <ul>
                        <li>
                            <a href="https://company.matcha-jp.com/company/">
                                {{
                                $t("header.company_profile")
                                }}
                            </a>
                        </li>
                        <li>
                            <a href="https://www.wantedly.com/companies/matcha/projects">
                                {{
                                $t("header.recruit")
                                }}
                            </a>
                        </li>
                        <li>
                            <a href="https://company.matcha-jp.com/info/">
                                {{
                                $t("header.contact_us")
                                }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div id="menuMask" v-on:click="closeMenu"></div>
            <div class="userMenu pc" id="beforeLogin" v-if="!this.isLogin">
                <router-link to="login" class="login btn btn-green btn-small">
                    {{
                    $t("header.user.login")
                    }}
                </router-link>
            </div>

            <div class="menuGroup userMenu pc" v-else>
                <ul id="dropdownMenu" class="dropdownMenu">
                    <li>
                        <div class="menuTitle arrow">
                            <avatar
                                style="margin-top: 10px"
                                v-if="this.avatar"
                                :username="this.avatar"
                                :size="40"
                                :src="this.user_info.photoURL ? this.user_info.photoURL : ''"
                            ></avatar>

                            <i class="icon-user" v-else></i>
                        </div>
                        <vue-slide-up-down
                            :dropDownActive="dropDownActive"
                            :duration="1000"
                            style="margin-top: 8px;"
                        >
                            <ul class="dropdown top_header">
                                <li>
                                    <router-link to="/">{{ $t("マイページ") }}</router-link>
                                </li>
                                <li>
                                    <router-link to="settings">
                                        {{
                                        $t("header.user.settings_modification")
                                        }}
                                    </router-link>
                                </li>
                                <li class="top_menu_listall">
                                    <a href="javascript:;" @click.prevent="logout()">
                                        {{ $t("header.user.logout") }}
                                        <span></span>
                                    </a>
                                </li>
                            </ul>
                        </vue-slide-up-down>
                    </li>
                </ul>
            </div>
            <form
                :action="constants.MATCHA_MEDIA_SSL_URL + languageName + '/search/?'"
                method="get"
                class="header_search icon-search"
            >
                <input type="search" name="keyword" :placeholder="$t('header.search')" />
                <span class="underline"></span>
                <button class="icon-search" type="submit"></button>
            </form>
        </div>
    </div>
</template>

<script>
import Avatar from "vue-avatar";
import * as firebase from "firebase/app";
import * as constants from "@/constants";
import VueSlideUpDown from "vue-slide-up-down";
import { mapState, mapGetters, mapMutations } from "vuex";
import et from "@/utils/event_tracker";
import Bowser from "bowser";
import {getUserIP, postDataToBigQuery} from '@/api/event_tracker'


export default {
    mounted() {

        getUserIP()
            .then(data => {
                this.user_ip = data.query;
                this.user_country = data.country;
            })

        this.$gtm.trackEvent({ isMember: true });

        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                let displayName = user.displayName,
                    email = user.email,
                    photoURL = user.photoURL;

                this.user_info = user;
                this.isLogin = true;
                this.avatar = photoURL
                    ? photoURL
                    : displayName
                    ? displayName
                    : email;
            } else {
                this.isLogin = false;
            }
        });
    },

    components: {
        VueSlideUpDown,
        Avatar
    },

    data: () => ({
        constants: constants,
        isLogin: false,
        user_info: "",
        avatar: "",
        dropDownActive: false,
        user_ip: '',
        user_country: ''
    }),

    computed: {
        ...mapGetters({
            accessToken: "accessToken",
            lang_id: "languageId",
            languageName: "languageName",
            userId: "userId",
            userAttributes: "userAttributes",
            email: "email",
            userMeta:"userMeta",    
        })
    },

    methods: {
        showDropDown: function(event) {
            var e = event.target;
            this.dropDownActive = !this.dropDownActive;
            var ua = navigator.userAgent;
            if (
                ua.indexOf("iPhone") > 0 ||
                ua.indexOf("iPod") > 0 ||
                (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
            ) {
                if (this.dropDownActive) {
                    e.classList.add("arrow-down");
                    e.nextElementSibling.style.display = "block";
                } else {
                    e.classList.remove("arrow-down");
                    e.nextElementSibling.style.display = "none";
                }
            }
        },

        isShowBookingMenu: function() {
            return ["jp", "en", "tw", "th", "ko", "cn", ].indexOf(this.languageName) >= 0;
        },

        isShowNewsMenu: function() {
            return ["en", "tw"].indexOf(this.languageName) >= 0;
        },

        openMenu: function() {
            let menu = document.getElementById("menu");
            menu.style.left = "0";
            let mask = document.getElementById("menuMask");
            mask.style.display = "block";
        },

        closeMenu: function() {
            let menu = document.getElementById("menu");
            menu.style.left = "-280px";
            let mask = document.getElementById("menuMask");
            mask.style.display = "none";
        },

        logout(e) {
            firebase
                .auth()
                .signOut()
                .then(result => {
                    window.localStorage.removeItem('__usrData');
                    // console.log(result)
                    // Sign-out successful.
                    this.closeMenu();
                })
                .catch(error => {
                    this.closeMenu();
                    // console.log(error)
                    // An error happened.
                });
        }
    },

    created(){

        var ga_clinetId = et.getCookie('_ga').split('.').slice(-2)[0];
        var browser_info = Bowser.getParser(window.navigator.userAgent);
        let device_info = browser_info.parsedResult;

        var JSONdata = {
            user_id: this.userId || 0,
            location_country: this.user_country,
            client_id: ga_clinetId ? ga_clinetId : et.getUniqueBrowserId().toString() + et.createOneHourUUID().toString(),
            visit_id: et.getUniqueBrowserId(),
            datetime: new Date().toISOString().replace(/T/, ' ').replace(/\..+/, ''),
            source_url: window.location.href,
            language_code: this.languageName,
            browser_language: et.getBrowserlanguage(),
            referrer: document.referrer,
            link_url: '',
            ip_source: this.user_ip, 
            device: device_info.platform.type,
            browser: device_info.browser.name + ' Version-' + parseFloat(device_info.browser.version).toString(),
            os: device_info.os.name + ' ' + device_info.os.versionName + ' ' +  device_info.os.version, 
            page_sequence: 1,
            search_word: '',
            user_agent: window.navigator.userAgent.toLowerCase(),
            action_type: 'pv'
        };

        postDataToBigQuery(JSONdata)

    }    
};
</script>

<style>
.image-cropper {
    width: 40px;
    height: 40px;
    position: relative;
    overflow: hidden;
    border-radius: 50%;
    top: 4px;
}
.profile-pic {
    display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/common/MainHeader.vue